<template>
    <b-modal scrollable ref="mdlTeamsystemintegrator" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl" @ok="onOk" @cancel="onClose">
        <div style="height: 100%">
            <!-- <b-row v-if="!editTestata">
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Tipo Documento</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.tipoDocumento }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice Fiscale</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.codiceFiscale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Ragione Sociale</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.ragioneSociale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Città</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.citta }} ({{ jsonDataFattura.Testata.provincia }})</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Cap</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.cap }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Indirizzo</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.indirizzo }}</span>
                        </b-col>
                    </b-row> v-else-->
            <b-row>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label_data">Ambulatorio</label>
                    <b-form-select v-model="idAmbulatorio" :options="ambulatoriOptions" :value="null" value-field="id" text-field="nome"></b-form-select>
                </b-col>
                <!-- <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Tipo Documento</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.tipoDocumento }}</span>
                        </b-col> -->
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Codice Fiscale</label>
                    <b-input-group class="mb-3">
                        <b-input-group class="mb-3">
                            <b-form-input maxlength="16" class="text-uppercase" v-model="jsonData.identificativo"></b-form-input>
                            <b-button size="sm" variant="" v-b-tooltip.hover title="Check Codice Fiscale" @click="onClickCodiceFiscale(jsonData.identificativo)"><b-icon icon="search"></b-icon></b-button>
                        </b-input-group>
                    </b-input-group>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Cognome</label>
                    <b-form-input v-model="jsonData.cognome" class="text-uppercase"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Nome</label>
                    <b-form-input v-model="jsonData.nome" class="text-uppercase"></b-form-input>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Provincia</label>
                    <b-form-select v-model="jsonDataFattura.Testata.provincia" :options="provinceOptions" value-field="text" text-field="text" @change="onChangeProvincia">
                        <template #first>
                            <b-form-select-option value="" disabled>- Seleziona Provincia -</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Città</label>
                    <b-form-select v-model="jsonDataFattura.Testata.citta" :options="comuniOptions" value-field="comune" text-field="comune" @change="setCap">
                        <template #first>
                            <b-form-select-option value="" disabled>- Seleziona Città -</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Cap</label>
                    <b-form-input v-model="jsonDataFattura.Testata.cap"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Indirizzo</label>
                    <b-form-input maxlength="16" class="text-uppercase" v-model="jsonDataFattura.Testata.indirizzo"></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <!-- <div class="b-table-sticky-header"> -->
                    <b-table head-variant="light" class="sa-b-table" sticky-header ref="table" stacked="lg" striped hover :items="jsonDataFattura.Corpo" :fields="fields" sort-icon-left>
                        <template #cell(index)="row">
                            <span> {{ row.index + 1 }} </span>
                        </template>
                        <template v-slot:cell(articolo)="row">
                            <span v-if="row.index != jsonDataFattura.Corpo.length - 1">{{ row.item.descrizione }} ({{ row.item.codiceArticolo }})</span>
                            <b-form-select v-else v-model="row.item.codiceArticolo" class="mb-2 mr-sm-2 mb-sm-0" :options="prodottiOptions" :value="''" text-field="name" value-field="_id" @change="onchangeProdotto(row.item)"> </b-form-select>
                        </template>
                        <template v-slot:cell(quantita)="{ item }">
                            <b-form-input v-model="item.quantita" type="number" min="1" step="1" @input="onChangeValue(item)" @change="normalizzaCampoNumerico(item, 'quantita')"></b-form-input>
                        </template>
                        <template v-slot:cell(aliquotaIva)="{ item }">
                            <b-form-select v-model="item.aliquotaIva" class="mb-2 mr-sm-2 mb-sm-0" :options="ivaOptions" :value="''" text-field="descrizione" value-field="aliquota"> </b-form-select>
                        </template>
                        <template v-slot:cell(prezzoUnitario)="{ item }">
                            <b-form-input v-model="item.prezzoUnitario" @input="onChangeValue(item)" @change="normalizzaCampoNumerico(item, 'prezzoUnitario')"></b-form-input>
                        </template>
                        <template #cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button v-if="row.index == jsonDataFattura.Corpo.length - 1" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAddRiga(jsonDataFattura.Corpo, row.item)">
                                    <b-icon icon="plus"></b-icon>
                                </b-button>
                                <b-button v-if="row.index !== jsonDataFattura.Corpo.length - 1" size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDelete(jsonDataFattura.Corpo, row)">
                                    <b-icon icon="trash"></b-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                    <!-- </div>

            <div class="b-table-sticky-header pagamenti-scroll"> -->
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-table head-variant="light" class="sa-b-table" ref="table" stacked="lg" striped hover :items="metodiPagamento" :fields="fieldsMetodiPagamento" sort-icon-left>
                        <template #cell(index)="row">
                            <span> {{ row.index + 1 }} </span>
                        </template>
                        <template v-slot:cell(articolo)="row">
                            <!-- <span v-if="row.index != metodiPagamento.length - 1">{{ row.item.descrizione }} ({{ row.item.codiceArticolo }})</span> -->
                            <b-form-select v-model="row.item.codiceArticolo" class="mb-2 mr-sm-2 mb-sm-0" :options="metodiPagamentoOptions" text-field="label" value-field="id" @change="onchangeMetodoPagamento(row.item)"> </b-form-select>
                        </template>
                        <template v-slot:cell(aliquotaIva)="{ item }">
                            <b-form-select v-model="item.aliquotaIva" class="mb-2 mr-sm-2 mb-sm-0" :options="ivaOptions" :value="''" text-field="descrizione" value-field="aliquota"> </b-form-select>
                        </template>
                        <template v-slot:cell(prezzoUnitario)="{ item }">
                            <b-form-input v-model="item.prezzoUnitario" @input="onChangeValue(item)" @change="normalizzaCampoNumerico(item, 'prezzoUnitario')"></b-form-input>
                        </template>
                        <template #cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button v-if="row.index == metodiPagamento.length - 1" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAddRigaMetodi(metodiPagamento, row.item)">
                                    <b-icon icon="plus"></b-icon>
                                </b-button>
                                <b-button v-if="row.index !== metodiPagamento.length - 1" size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDelete(metodiPagamento, row)">
                                    <b-icon icon="trash"></b-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <!-- </div> -->
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Note:</label>
                    <b-form-textarea v-model="jsonData.note" rows="3" no-resize></b-form-textarea>
                </b-col>
                <b-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="sa-padding-left text-left">
                    <label class="sa-label-data">Totale Versato:</label>
                    <span class="sa-data">{{ totaleVersato }}</span> </b-col
                ><b-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="sa-padding-right text-right">
                    <label class="sa-label-data">Totale:</label>
                    <span class="sa-data">{{ totaleResiduo }}</span>
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>

<script>
import axios from "axios";
import moment from "moment";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/teamsystemintegratorresponse",
            pathResourcePazienti: "/pazienti",
            pathResourceIva: "/teamsystemintegratoriva",
            pathResourceProdotti: "/externalprenotazioni/listaprodotti",
            pathResourceMetodiPagamento: "/externalbotox/metodipagamenti",
            pathResourcePrezzi: "/externalprenotazioni/prezzo",
            // NUOVI PATH RICHIESTI
            pathResourceProvince: "/province",
            pathResourceComuni: "/comuni/provincia",
            ambulatoriOptions: [],
            idAmbulatorio: null,
            pathResourceAmbulatori: "/ambulatoriutenti",
            title: "Modifica Fattura",
            ivaOptions: [],
            prodottiOptions: [],
            provinceOptions: [],
            comuniOptions: [],
            editTestata: false,
            jsonData: {},
            metodiPagamento: [],
            metodiPagamentoOptions: [],
            rigaSelezionata: {},
            totaleDocuemnto: 0,
            totaleVersato: 0,
            jsonDataFattura: { Testata: {}, Corpo: [] },
            fields: [
                { label: "*", key: "index", thStyle: "width: 0.5rem" },
                { label: "Articolo", key: "articolo" },
                { label: "Iva", key: "aliquotaIva", thStyle: "width: 10rem" },
                { label: "Quantita", key: "quantita", thStyle: "width: 5rem" },
                { label: "U.M.", key: "unitaMisura", thStyle: "width: 5rem" },
                { label: "Prezzo Unitario", key: "prezzoUnitario", thStyle: "width: 5rem" },
                { label: "Totale", key: "importoTotale", thStyle: "width:5rem" },
                { key: "actions", label: "", class: "sa-table-column-action-double" },
            ],
            fieldsMetodiPagamento: [
                { label: "*", key: "index", thStyle: "width: 0.5rem" },
                { label: "Metodo Pagamento", key: "articolo" },
                { label: "Versato", key: "prezzoUnitario", thStyle: "width: 10rem" },
                { key: "actions", label: "", class: "sa-table-column-action-double" },
            ],
        };
    },
    computed: {
        totaleResiduo() {
            return Math.round((this.totaleDocuemnto - this.totaleVersato + Number.EPSILON) * 100) / 100;
        },
    },
    methods: {
        init(id) {
            let me = this;
            me.id = id;
            this.loadAmbulatori();
            if (me.id === null) {
                me.$emit("afterLoadData");
                me.editTestata = true;
                me.jsonData = {
                    identificativo: "",
                    cognome: "",
                    nome: "",
                    note: "",
                };
                me.jsonDataFattura.Testata = { tipoDocumento: "3", serieBolla: "006", numeroBolla: "0", codiceCliente: "0", ragioneSociale: "", indirizzo: "", cap: "", citta: "", provincia: "", codiceFiscale: "", partitaIva: "0", codicePagamento: "301", codiceAgente: "0", codiceDeposito: "0", codiceBanca: "0", codiceAgenzia: "0", dataBolla: moment(new Date()).format("YYYYMMDD").toUpperCase(), tipoIva: "0", causaleTrasporto: "1", vettore: "0", totaleColli: "1" };
                me.jsonDataFattura.Corpo = [{ unitaMisura: "NR", descrizione: "", codiceArticolo: "", quantita: "", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "580505", agenteDettaglio: "0" }];
                me.metodiPagamento = [{ unitaMisura: "PG", descrizione: "", codiceArticolo: "", quantita: "1", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "0", agenteDettaglio: "0", aliquotaIva: "0" }];
                me.rigaSelezionata = {};
                me.totaleDocuemnto = 0;
                me.totaleVersato = 0;
                this.$refs.mdlTeamsystemintegrator.show();
            } else {
                me.editTestata = false;
                me.$emit("beforeLoadData");
                me.loadData();
            }
            this.$emit("afterLoadData");
            me.loadIva();
            me.loadProdotti();
            me.loadMetodiPagamento();
            me.loadProvince(); // Carica l'elenco province all'avvio
        },
        onClose() {
            let me = this;
            me.jsonDataFattura = { Testata: {}, Corpo: [] };
            me.metodiPagamento = [];
            me.$refs.mdlTeamsystemintegrator.hide();
        },
        // CARICAMENTO PROVINCE
        loadProvince() {
            let me = this;
            me.provinceOptions = [];
            UtilityMixin.methods.loadDataResources(
                me.pathResourceProvince + "?language=it",
                null,
                (response) => {
                    response.data.data.forEach((element) => {
                        me.provinceOptions.push({ value: element.provincia, text: element.provincia, sigla: element.sigla });
                    });
                    let provinciaSelezionata = me.provinceOptions.find((provincia) => provincia.value === me.jsonDataFattura.Testata.provincia || provincia.sigla === me.jsonDataFattura.Testata.provincia);
                    if (provinciaSelezionata) {
                        me.jsonDataFattura.Testata.provincia = provinciaSelezionata.text;
                        me.loadComuni(provinciaSelezionata.sigla);
                    }
                },
                (err) => console.error(err),
            );
        },

        // GESTIONE CAMBIO PROVINCIA -> CARICAMENTO COMUNI
        onChangeProvincia() {
            let me = this;
            let provinciaSelezionata = me.provinceOptions.find((provincia) => provincia.text === me.jsonDataFattura.Testata.provincia);
            me.jsonDataFattura.Testata.citta = ""; // Reset città
            if (provinciaSelezionata) {
                me.loadComuni(provinciaSelezionata.sigla);
            } else {
                me.comuniOptions = [];
            }
        },

        loadComuni(siglaProvincia) {
            let me = this;
            // Chiamata all'endpoint linkComune concatenando la sigla
            let link = me.pathResourceComuni + "/" + siglaProvincia;
            UtilityMixin.methods.loadDataResources(
                link,
                null,
                (res) => {
                    me.comuniOptions = res.data.data.list || res.data.data;
                    let cittaSelezionata = me.comuniOptions.find((comune) => comune.comune === me.jsonDataFattura.Testata.citta || comune.codiceIstat === me.jsonDataFattura.Testata.citta);
                    if (cittaSelezionata) me.jsonDataFattura.Testata.citta = cittaSelezionata.comune;
                },
                (err) => console.error(err),
            );
        },

        loadData() {
            let me = this;
            let link = me.pathResource + "/" + me.id;
            UtilityMixin.methods.loadDataResources(link, null, me.loadDataSuccess, me.loadDataError);
        },
        loadAmbulatori() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAmbulatori;
            me.ambulatoriOptions = [];
            axios.get(link).then((response) => {
                me.ambulatoriOptions = response.data.data;
                if (me.ambulatoriOptions.length > 1) {
                    me.ambulatoriOptions.unshift({ id: null, nome: "-Seleziona Valore-" });
                    if (me.id !== null) this.loadData();
                } else if (me.ambulatoriOptions.length === 1) {
                    me.idAmbulatorio = me.ambulatoriOptions[0].id;
                    if (me.id !== null) this.loadData();
                }
            });
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonDataFattura = JSON.parse(me.jsonData.body);
            me.jsonDataFattura.Corpo.push({ unitaMisura: "NR", descrizione: "", codiceArticolo: "", quantita: "", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "580505", agenteDettaglio: "0" });
            me.metodiPagamento = [{ unitaMisura: "PG", descrizione: "", codiceArticolo: "", quantita: "1", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "0", agenteDettaglio: "0", aliquotaIva: "0" }];

            if (me.jsonDataFattura.Testata.provincia) {
                let provinciaSelezionata = me.provinceOptions.find((provincia) => provincia.value === me.jsonDataFattura.Testata.provincia || provincia.sigla === me.jsonDataFattura.Testata.provincia);
                if (provinciaSelezionata) {
                    me.jsonDataFattura.Testata.provincia = provinciaSelezionata.text;
                    me.loadComuni(provinciaSelezionata.sigla);
                }
            }

            me.$emit("afterLoadData");
            me.calcolaTotale();
            this.$refs.mdlTeamsystemintegrator.show();
        },

        // Resto della logica (IVA, Prodotti, Salvataggio, Calcoli) invariata...
        loadDataError(error) {
            error;
            this.$emit("afterLoadData");
        },
        loadIva() {
            let me = this;
            UtilityMixin.methods.loadDataResources(
                me.pathResourceIva,
                null,
                (res) => {
                    me.ivaOptions = res.data.data.list;
                    me.ivaOptions.unshift({ aliquota: "", descrizione: "-Seleziona Valore-" });
                },
                (err) => {
                    err;
                },
            );
        },
        loadProdotti() {
            let me = this;
            UtilityMixin.methods.loadDataResources(
                me.pathResourceProdotti,
                null,
                (res) => {
                    me.prodottiOptions = res.data.data.products;
                    me.prodottiOptions.unshift({ _id: "", name: "-Seleziona Valore-" });
                },
                (err) => {
                    err;
                },
            );
        },
        loadMetodiPagamento() {
            let me = this;
            UtilityMixin.methods.loadDataResources(
                me.pathResourceMetodiPagamento,
                null,
                (res) => {
                    me.metodiPagamentoOptions = res.data.data;
                    me.metodiPagamentoOptions.unshift({ id: "", label: "-Seleziona Valore-" });
                },
                (err) => {
                    err;
                },
            );
        },
        onOk() {
            let me = this;
            if (me.editTestata) {
                me.jsonData.idEvento = "";
                me.jsonData.response = "";
                me.jsonData.status = "";
                me.jsonData.idAmbulatorio = me.idAmbulatorio;
                me.jsonData.dataOra = new Date().getTime();
                me.jsonData.statoAttualeDataOra = new Date().getTime();
                me.jsonData.statoAttuale = "DA INVIARE";
            }
            let corpo = [];
            me.jsonDataFattura.Corpo.forEach((element) => {
                if (element.codiceArticolo !== "") {
                    me.normalizzaRiga(element);
                    corpo.push(element);
                }
            });
            me.metodiPagamento.forEach((element) => {
                if (element.codiceArticolo !== "") {
                    me.normalizzaRiga(element);
                    corpo.push(element);
                }
            });
            me.jsonDataFattura.Testata.ragioneSociale = me.jsonData.cognome + " " + me.jsonData.nome;
            me.jsonDataFattura.Testata.codiceFiscale = me.jsonData.identificativo;
            me.jsonDataFattura.Corpo = corpo;
            me.jsonData.prestazione = corpo
                .filter((articolo) => articolo.unitaMisura === "NR")
                .map((articolo) => String(articolo.descrizione).trim())
                .join(", ");
            me.jsonData.body = JSON.stringify(me.jsonDataFattura);
            me.saveResource(
                this.pathResource,
                this.jsonData,
                () => me.$emit("afterSave"),
                (err) => {
                    err;
                },
            );
        },
        onChangeValue(item) {
            let qta = parseFloat(String(item.quantita).replace(",", ".")) || 0;
            let prezzo = parseFloat(String(item.prezzoUnitario).replace(",", ".")) || 0;
            item.importoTotale = (qta * prezzo).toFixed(2).replace(".", ",");
            this.calcolaTotale();
        },
        formattaQuantita(value) {
            let numero = Number(String(value).replace(",", "."));
            if (!Number.isInteger(numero) || numero < 1) return "";
            return String(numero);
        },
        formattaPrezzo(value) {
            let numero = parseFloat(String(value).replace(",", "."));
            if (!Number.isFinite(numero)) return "";
            return numero.toFixed(2).replace(".", ",");
        },
        normalizzaCampoNumerico(item, campo) {
            item[campo] = campo === "prezzoUnitario" ? this.formattaPrezzo(item[campo]) : this.formattaQuantita(item[campo]);
            this.onChangeValue(item);
        },
        normalizzaRiga(item) {
            item.quantita = this.formattaQuantita(item.quantita);
            item.prezzoUnitario = this.formattaPrezzo(item.prezzoUnitario);
            let qta = parseFloat(String(item.quantita).replace(",", ".")) || 0;
            let prezzo = parseFloat(String(item.prezzoUnitario).replace(",", ".")) || 0;
            item.importoTotale = this.formattaPrezzo(qta * prezzo);
        },
        calcolaTotale() {
            let me = this;
            me.totaleDocuemnto = 0;
            me.totaleVersato = 0;
            me.jsonDataFattura.Corpo.forEach((element) => {
                if (element.unitaMisura === "NR") {
                    me.totaleDocuemnto += parseFloat(String(element.importoTotale).replace(",", ".")) || 0;
                } else if (element.unitaMisura === "PG") {
                    me.totaleVersato += parseFloat(String(element.importoTotale).replace(",", ".")) || 0;
                }
            });
            me.metodiPagamento.forEach((element) => {
                me.totaleVersato += parseFloat(String(element.importoTotale).replace(",", ".")) || 0;
            });
            me.totaleDocuemnto = Math.round((me.totaleDocuemnto + Number.EPSILON) * 100) / 100;
            me.totaleVersato = Math.round((me.totaleVersato + Number.EPSILON) * 100) / 100;
        },
        onAddRiga(array, value) {
            if (value.descrizione !== "") {
                array.push({ unitaMisura: "NR", descrizione: "", codiceArticolo: "", quantita: "", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "580505", agenteDettaglio: "0" });
                this.calcolaTotale();
            } else {
                this.$bvModal.msgBoxOk("Dati non validi!", { title: "ATTENZIONE", size: "sm", okVariant: "outline-danger", centered: true });
            }
            this.calcolaTotale();
        },
        onAddRigaMetodi(array, value) {
            if (value.descrizione !== "") {
                array.push({ unitaMisura: "PG", descrizione: "", codiceArticolo: "", quantita: "1", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "0", agenteDettaglio: "0" });
                this.calcolaTotale();
            } else {
                this.$bvModal.msgBoxOk("Dati non validi!", { title: "ATTENZIONE", size: "sm", okVariant: "outline-danger", centered: true });
            }
            this.calcolaTotale();
        },
        onchangeProdotto(item) {
            let me = this;
            me.prodottiOptions.forEach((element) => {
                if (element._id === item.codiceArticolo) {
                    item.descrizione = element.name;
                    item.quantita = "1";
                    me.rigaSelezionata = item;
                    me.getPrezzoArticolo(item.codiceArticolo);
                }
            });
        },
        onchangeMetodoPagamento(item) {
            let me = this;
            me.metodiPagamentoOptions.forEach((element) => {
                if (element.id === item.codiceArticolo) {
                    item.descrizione = element.label;
                }
            });
        },
        getPrezzoArticolo(codiceArticolo) {
            let me = this;
            UtilityMixin.methods.loadDataResources(
                this.pathResourcePrezzi + "/" + codiceArticolo,
                null,
                (res) => {
                    me.rigaSelezionata.prezzoUnitario = me.formattaPrezzo(res.data.data.amount);
                    me.onChangeValue(me.rigaSelezionata);
                },
                (err) => {
                    err;
                },
            );
        },
        onClickCodiceFiscale(value) {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResourcePazienti + "/identificativo/" + value.trim().toUpperCase();
            UtilityMixin.methods.restCallGet(path, null, me.checkPresentAnagraficaSuccess, me.checkPresentAnagraficaError);
        },
        checkPresentAnagraficaSuccess(response) {
            let me = this;
            let paziente = response.data.data;
            me.jsonData.nome = paziente.nome;
            me.jsonData.cognome = paziente.cognome;
            me.jsonData.identificativo = paziente.identificativo;
            me.jsonDataFattura.Testata.provincia = paziente.provinciaResidenza;
            me.loadProvince();
            me.onChangeProvincia();
            me.jsonDataFattura.Testata.citta = paziente.comuneResidenzaCodiceIstat;
            me.jsonDataFattura.Testata.cap = paziente.capResidenza;
            me.jsonDataFattura.Testata.indirizzo = paziente.indirizzoResidenza;

            me.setCap();
        },
        checkPresentAnagraficaError(error) {
            // let me = this;
            error;
        },
        // checkCodiceFiscale(codiceFiscale) {
        //     let me = this;
        //     if (me.codiceFiscaleValido) {
        //         let path = "/utilityanagrafica/codicefiscale";
        //         me.loadDataResources(path, { codiceFiscale: codiceFiscale }, me.resultResponseCodiceFiscale, me.resultErrorCodiceFiscale);
        //     } else {
        //         me.$bvToast.toast("Codice Fiscale non corretto", {
        //             title: "Errore",
        //             variant: "danger",
        //             solid: true,
        //         });
        //     }
        // },
        // resultResponseCodiceFiscale(response) {
        //     let me = this;
        //     me.anagraficaInfo = response.data.data;
        //     me.paziente.dataNascita = me.anagraficaInfo.dataNascita;
        //     me.paziente.sesso = me.anagraficaInfo.sesso;
        //     me.paziente.comuneNascitaCodiceIstat = me.anagraficaInfo.comuneNascitaCodiceIstat;
        //     me.paziente.provinciaNascita = me.anagraficaInfo.provinciaNascita;
        //     me.loadComuni(me.paziente.provinciaNascita, "nascita");
        // },
        // resultErrorCodiceFiscale(error) {
        //     let me = this;
        //     let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
        //     me.$bvToast.toast("Errore durante il caricamento: " + messaggio, {
        //         title: "Errore",
        //         variant: "danger",
        //         solid: true,
        //     });
        // },
        setCap(value) {
            let me = this;
            me.comuniOptions.forEach((comune) => {
                if (comune.comune === value || comune.codiceIstat === value) {
                    me.jsonDataFattura.Testata.cap = comune.cap;
                }
            });
        },
        onDelete(array, row) {
            if (row.index != array.length) {
                this.$bvModal
                    .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                        title: "Titolo",
                        buttonSize: "sm",
                        okVariant: "secondary",
                        cancelVariant: "danger",
                        okTitle: "SI",
                        cancelTitle: "NO",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            array.splice(row.index, 1);
                            this.calcolaTotale();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
    },
};
</script>

<style scoped></style>
